import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  HostListener,
} from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AuthenticationDataModel,
  AuthenticationNgRxActions,
} from '@geekbears/gb-ngrx-auth-basic';
import { getFailureMessageRxOp } from '@geekbears/gb-ngrx-stack-base';
import { NotificationsService } from '@geekbears/ngx-gb-ui-kit';
import { Store } from '@ngrx/store';
import { isNil } from 'lodash';
import { filter, map, Observable, Subject, takeUntil, tap } from 'rxjs';
import { Actions, ofType } from '@ngrx/effects';
import { NavigationService } from '@core/application';
import { SessionService } from '@core/application/session.service';

import {
  confirmAccountFailureAction,
  confirmAccountSuccessAction,
  forgotPasswordSuccessAction,
  resendEmailSuccessAction,
  UsersActions,
  confirmAccountLoadingSelector,
  resendEmailLoadingSelector,
  resetPasswordCodeSelector,
  verifyAuthTokenFailureAction,
  verifyAuthTokenSuccessAction,
} from '@modules/company-manager/users/application';
import { AppUserModel } from '@modules/company-manager/users/infrastructure';
import { AppUser } from '@modules/company-manager/users/domain';

@Component({
  selector: 'app-confirm-account',
  templateUrl: './confirm-account.page.html',
  styleUrls: ['./confirm-account.page.scss'],
})
export class ConfirmAccountComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild('templateBottomSheet') TemplateBottomSheet!: TemplateRef<any>;
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  destroy$: Subject<void> = new Subject();
  code: string = '';
  email: string = '';
  form!: FormGroup;
  errorMessage$!: string;
  currentUser!: AppUser;
  requirePasswordChange: boolean = false;
  requireChangePersonalInformation: boolean = false;
  confirmAccountLoading$: Observable<boolean | any>;
  singUpProcess: boolean = false;
  resendEmailLoading$: Observable<boolean | undefined>;
  isDisabled: boolean = false;
  isLoginFlow: boolean = false;
  isMobile: boolean = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private notifications: NotificationsService,
    private store$: Store,
    private actions$: Actions,
    private bottomSheet: MatBottomSheet,
    private activatedRoute: ActivatedRoute,
    private navigationService: NavigationService,
    private sessionService: SessionService
  ) {
    this.isMobile = window.innerWidth < 680;
    this.resendEmailLoading$ = this.store$.select(resendEmailLoadingSelector);
    this.confirmAccountLoading$ = this.store$
      .select(confirmAccountLoadingSelector)
      .pipe(
        tap((status) => {
          if (status) {
            this.isDisabled = true;
          }
        })
      );
    this.form = this.fb.group({
      code: ['', [Validators.required, Validators.minLength(6)]],
    });
    this.currentUser = JSON.parse(localStorage.getItem('s_user') || '{}');
    if (this.currentUser && this.currentUser._companyId == null)
      this.singUpProcess = true;
  }

  ngOnInit(): void {
    this.onFailureActions();
    this.getResetPasswordEmail();
    this.getParams();
    this.onEmailSentSuccess();
    this.onConfirmAccountSuccess();
    this.onVerifyAuthTokenSuccess();
    this.onResendEmailSuccess();

    setTimeout(() => {
      // this.ngOtpInputRef.setValue('333000');
    }, 1000);
  }
  ngAfterViewInit(): void {}
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  onEmailSentSuccess() {
    this.actions$
      .pipe(
        ofType(forgotPasswordSuccessAction),
        filter((action) => {
          return !isNil(action.response);
        }),
        map((action: any) => {
          this.notifications.success('Email sent');
          return action.response.data;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  getResetPasswordCode() {
    this.store$
      .select(resetPasswordCodeSelector)
      .pipe(
        map((response) => {
          if (response) {
            this.code = response ? response : '';
          } else {
          }
        })
      )
      .subscribe();
  }

  getResetPasswordEmail() {
    this.email = localStorage.getItem('resetPasswordEmail') || '';
  }

  checkCode() {
    if (this.form.valid && this.isDisabled == false) {
      const code = this.form.get('code')?.value;
      if (this.isLoginFlow) {
        this.store$.dispatch(
          UsersActions.verifyAuthToken({
            confirmAccountToken: code,
          })
        );
      } else {
        this.store$.dispatch(
          UsersActions.confirmAccount({
            confirmAccountToken: code,
          })
        );
      }
    }
  }

  onConfirmAccountSuccess() {
    this.actions$
      .pipe(
        ofType(confirmAccountSuccessAction),
        filter((action) => {
          return !isNil(action.response);
        }),
        map((action: any) => {
          if (action.response?.success) {
            this.successModal('Account confirmed successfully');
            localStorage.removeItem('confirmAccountToken');
            if (this.changeDataOnStorage()) {
              const signupRole = localStorage.getItem('signup_role');
              if (signupRole === 'company-administrator') {
                this.router.navigateByUrl('/authentication/admin-info');
              } else if (this.singUpProcess) {
                // this.router.navigateByUrl(
                //   '/authentication/company-information'
                // );
                this.router.navigateByUrl('/authentication/admin-info');
              } else if (this.requirePasswordChange == true) {
                this.router.navigateByUrl(
                  '/authentication/change-default-password'
                );
              } else if (this.requireChangePersonalInformation == true) {
                this.router.navigateByUrl(
                  '/authentication/personal-information'
                );
              } else if (this.currentUser.hasActiveSubscription == false && !this.currentUser.isSubscriptionBypassed && !this.currentUser.company?.isSubscriptionBypassed) {
                setTimeout(() => {
                  this.router.navigateByUrl('/authentication/pick-plan');
                }, 2000);
              } else {
                this.router.navigateByUrl('/dashboard');
              }
            }
          } else {
            this.errorModal(action.response?.message || 'Incorrect OTP');
            this.isDisabled = false;
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  onVerifyAuthTokenSuccess() {
    this.actions$
      .pipe(
        ofType(verifyAuthTokenSuccessAction),
        filter((action) => {
          return !isNil(action.response);
        }),
        tap((action: any) => {
          const user = action.response.user;
          const authToken = action.response.authToken;
          const refreshToken = action.response.refreshToken;
          const userId = user?.id || user?._id;

          const url = action.response.url;

          if (user) {
            localStorage.setItem('s_user', JSON.stringify(user));
          }

          if (authToken) {
            localStorage.setItem('auth_token', authToken);
          }

          if (refreshToken) {
            localStorage.setItem('refresh_token', refreshToken);
          }

          const screenWidth = window.screen.width;
          // console.log('OTP Verification Success. URL:', url, 'ScreenWidth:', screenWidth);
          if (url && screenWidth < 680) {
            localStorage.setItem('from_mobile', 'true');
            localStorage.setItem('return_url', url);
            // console.log('Saved return_url to localStorage:', url);
          }

          if (authToken && userId) {
            this.store$.dispatch(
              AuthenticationNgRxActions.setAuthSession({
                data: new AuthenticationDataModel({
                  id: userId,
                  token: authToken,
                  refreshToken: refreshToken,
                  user: user,
                }),
              })
            );
          }

          this.successModal('Account Confirmed successfully');

          setTimeout(() => {
            if (user?.hasActiveSubscription === false && !user?.isSubscriptionBypassed && !user?.company?.isSubscriptionBypassed) {
              this.router.navigateByUrl('/authentication/pick-plan');
            } else {
              this.router.navigateByUrl('/dashboard');
            }
          }, 3000);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  onResendEmailSuccess() {
    this.actions$
      .pipe(
        ofType(resendEmailSuccessAction, UsersActions.sendCodeSuccess),
        filter((action) => {
          return !isNil(action.response);
        }),
        map((action) => {
          if (action) {
            this.successModal('Email Successfully Sent');
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  changeDataOnStorage() {
    let currentUserOnStorage = JSON.parse(
      localStorage.getItem('s_user') || '{}'
    );
    currentUserOnStorage.confirmAccountToken = null;
    localStorage.setItem('s_user', JSON.stringify(currentUserOnStorage));

    return true;
  }

  sendAgain() {
    if (this.isLoginFlow && this.email) {
      this.store$.dispatch(UsersActions.sendCode({ email: this.email }));
      return;
    }

    const email = localStorage.getItem('signup_email');
    const password = localStorage.getItem('signup_password');

    if (email && password) {
      this.store$.dispatch(UsersActions.sendCode({ email, password }));
    } else {
      this.store$.dispatch(UsersActions.resendEmail());
    }
  }

  successModal(message: string) {
    this.notifications.success(message, {
      duration: 4000,
      icon: 'check-circle',
    });
  }
  errorModal(message: string) {
    this.notifications.error(message, {
      duration: 4000,
      icon: 'alert-outline',
    });
  }
  getParams = async () => {
    const code = await this.getUserAccountConfirmCodeFromStorage();

    this.activatedRoute.queryParams
      .pipe(map((params) => params))
      .subscribe(async (params: any) => {
        if (params?.newUser === 'true') {
          this.sessionService.clearSession();
          this.currentUser = {} as any;
          this.singUpProcess = false;
        }
        this.isLoginFlow = params?.login === 'true';
        if (params?.email) {
          this.email = params.email;
        }
        if (params?.code) {
          setTimeout(() => {
            this.ngOtpInputRef.setValue(params?.code);
          }, 0);
        } else this.getTokenFromStore();
      })
      .unsubscribe();
  };

  getUserAccountConfirmCodeFromStorage = async () => {
    const currentUser = JSON.parse(localStorage.getItem('s_user') || '{}');
    this.requirePasswordChange = currentUser.requiresPasswordChange;

    if (currentUser.firstName == '##N/A##' || currentUser.lastName == '##N/A##')
      this.requireChangePersonalInformation = true;

    return currentUser.confirmAccountToken;
  };

  onFailureActions() {
    this.actions$
      .pipe(
        ofType(
          confirmAccountFailureAction,
          verifyAuthTokenFailureAction
        ),
        map((action) => {
          return action.failure;
        }),
        getFailureMessageRxOp(),
        tap((errorMessage) => {
          setTimeout(() => {
            this.isDisabled = false;
          }, 1500);
          if (errorMessage) {
            this.notifications.error(errorMessage, {
              duration: 5000,
              icon: 'alert-outline',
            });
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
  back() {
    // localStorage.clear();
    localStorage.removeItem('s_admin');
    localStorage.removeItem('confirmAccountToken');
    localStorage.removeItem('confirmAccountEmail');
    this.store$.dispatch(AuthenticationNgRxActions.logout());
  }
  
  goBack() {
    this.navigationService.back();
  }

  getTokenFromStore() {
    const code = localStorage.getItem('confirmAccountToken');

    if (code) {
      // this.ngOtpInputRef.setValue(code);
    }
  }
  logOut() {
    this.bottomSheet.dismiss();
    // localStorage.clear();
    localStorage.removeItem('s_admin');
    localStorage.removeItem('confirmAccountToken');
    localStorage.removeItem('confirmAccountEmail');
    this.store$.dispatch(AuthenticationNgRxActions.logout());
  }
  openBottomSheet() {
    this.bottomSheet.open(this.TemplateBottomSheet);
  }

  closeTemplateSheetMenu() {
    this.bottomSheet.dismiss();
  }
  onOtpChange(event: any) {
    this.form.get('code')?.setValue(event);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth < 680;
  }
}
